import React from "react";
import ActionButton from "../utils/ActionButton";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";
import CountyMap from "./CountyMap";

const UtahCounties = () => {
  return (
    <>
      <div>
        <LandingSection
          data={{ imageName: "geoandinsights.webp", title: "Utah Counties" }}
        />
        <div className="verticals_section">
          <div className="verticals-intro">
            <div className="verticals-intro-sec1">
              <h2>
                Utah Counties: Diverse Landscapes and Economic Roles Balancing
                Urban Growth with Rural Heritage
              </h2>
            </div>
            <div className="verticals-intro-sec2">
              <p>
                Utah is divided into 29 counties, each offering unique cultural,
                economic, and geographic characteristics. Salt Lake County, the
                most populous, serves as the state’s economic and cultural hub,
                home to the capital city and major industries ranging from
                finance to technology.
              </p>
              {/* <ActionButton data="Explore More" /> */}
            </div>
          </div>
        </div>
        <CountyMap />
        <Footer />
      </div>
    </>
  );
};

export default UtahCounties;
